.functions_code {
    height: 130px !important;
}